import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  addData: {},
  sorted: [],
};

const slice = createSlice({
  name: 'PaymentTypeRedux',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    // GET PaymentTypesManagement
    getPaymentTypesSuccess(state, action) {
      state.data = action.payload.data;
    },

    addOrUpdatePaymentTypes(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getPaymentTypes(options = {}) {
  return async () => {
    try {
      const queryParams = [];
      if (options.includeLocations) {
        queryParams.push('includeLocations=true');
      }
      const response = await get(`PaymentTypes${queryParams.length > 0 ? `?${queryParams.join('&')}` : ''}`);
      if (response.status) {
        dispatch(slice.actions.getPaymentTypesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addPaymentTypes(body) {
  return async () => {
    try {
      const response = await post(`PaymentTypes`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdatePaymentTypes(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updatePaymentTypes(body) {
  return async () => {
    try {
      const response = await put(`PaymentTypes`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdatePaymentTypes(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
